import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {
  GCS_OAUTH_TOKEN,
  PENDING_DRIVE_LABEL_CREATION,
  PENDING_OAUTH_RETURN_URL,
  PENDING_OAUTH_SCOPES,
  PENDING_OAUTH_TOKEN_KEY,
  SCOPES
} from './app/constants/local-storage-constants';

// Handle the OAuth 2.0 implicit-grant redirect from Google before Angular boots.
// Under useHash:true routing, Angular would otherwise interpret #access_token=...
// as an unknown route and drop the OAuth response. Run synchronously here, store
// the token, then redirect back to the original page.
function clearPendingOauthState(): void {
  localStorage.removeItem(PENDING_OAUTH_RETURN_URL);
  localStorage.removeItem(PENDING_OAUTH_SCOPES);
  localStorage.removeItem(PENDING_OAUTH_TOKEN_KEY);
  localStorage.removeItem(PENDING_DRIVE_LABEL_CREATION);
}

function handleOauthScopeRedirect(): void {
  const returnUrl = localStorage.getItem(PENDING_OAUTH_RETURN_URL);
  if (!returnUrl) {
    return;
  }
  const hash = window.location.hash;

  // Consent denied or otherwise failed: drop the pending state, otherwise the
  // action waiting on the grant would fire without a token on a later visit.
  if (hash.includes('error=') || window.location.search.includes('error=')) {
    clearPendingOauthState();
    window.location.replace(returnUrl);
    return;
  }

  if (!hash || !hash.includes('access_token=')) {
    return;
  }
  const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
  const token = params.get('access_token');
  if (!token) {
    return;
  }
  localStorage.setItem(localStorage.getItem(PENDING_OAUTH_TOKEN_KEY) || GCS_OAUTH_TOKEN, token);

  const pendingScopes = localStorage.getItem(PENDING_OAUTH_SCOPES);
  if (pendingScopes) {
    const existing = (localStorage.getItem(SCOPES) || '').split(' ').filter(s => s.length > 0);
    const merged = Array.from(new Set([...existing, ...pendingScopes.split(' ')])).join(' ');
    localStorage.setItem(SCOPES, merged);
  }

  localStorage.removeItem(PENDING_OAUTH_RETURN_URL);
  localStorage.removeItem(PENDING_OAUTH_SCOPES);
  localStorage.removeItem(PENDING_OAUTH_TOKEN_KEY);

  window.location.replace(returnUrl);
}

handleOauthScopeRedirect();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
